import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import './NewCommunities.css';
import { Button, Avatar, AvatarGroup } from '@mui/material';
import vector from './vector.svg';
import { doc, updateDoc, query, where, arrayUnion, getDoc, collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import { UserContext } from '../../context/UserContext';

const NewCommunities = () => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const [communities, setCommunities] = useState([]);

  useEffect(() => {
    if (!user) return;
    const fetchCommunities = async () => {
      const querySnapshot = await getDocs(collection(db, "groups"));
      const communityList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      const userGroupsQuery = query(collection(db, "groups"), where("members", "array-contains", user.uid));
      const userGroupsSnapshot = await getDocs(userGroupsQuery);
      const userGroupIds = new Set(userGroupsSnapshot.docs.map(doc => doc.id));

      const newCommunities = communityList.filter(community => !userGroupIds.has(community.id));
      setCommunities(newCommunities);
    };

    fetchCommunities();
  }, [user]);

  const joinGroup = async (groupId, conversationId) => {
    if (!user) return;

    const userRef = doc(db, "UserInformation", user.uid);
    const userDoc = await getDoc(userRef);
    let userAvatarUrl = "";

    if (userDoc.exists()) {
      userAvatarUrl = userDoc.data().profilePictureUrl || "";
    }

    const groupRef = doc(db, "groups", groupId);
    const groupDoc = await getDoc(groupRef);

    if (groupDoc.exists()) {
      const groupData = groupDoc.data();
      let updatedAvatars = groupData.memberAvatars || [];

      // Ensure only the latest 3 avatars are kept
      if (userAvatarUrl) {
        updatedAvatars = [userAvatarUrl, ...updatedAvatars].slice(0, 3);
      }
      await updateDoc(groupRef, {
        members: arrayUnion(user.uid),
        memberAvatars: updatedAvatars
      });

      const conversationRef = doc(db, "conversations", conversationId);
      await updateDoc(conversationRef, {
          participants: arrayUnion(user.uid)
      });
      console.log("joined group, Navigating to messages!");
      navigate(`/messages?group=${conversationId}`); // Redirect to messages
    } else {
      console.warn("Attempted to join a non-existent group.");
    }
  };

  return (
    <div className="new-communities" style={{ backgroundColor: '#FFFFFF' }}>
      <h2 className="section-title">New communities</h2>
      <div className="communities-grid">
        {communities.map(community => (
          <div key={community.id} className="community-card">
            <div className="community-image-container">
              <img src={community.image} alt={community.title} className="community-image" />
            </div>
            <div className="community-content">
              <h3 className="community-title">{community.title}</h3>
              <div className="community-members">
                <AvatarGroup max={3} sx={{ '& .MuiAvatar-root': { width: 24, height: 24, fontSize: '0.8rem' } }}>
                  {(community.memberAvatars || []).map((avatar, index) => (
                    <Avatar key={index} src={avatar} />
                  ))}
                </AvatarGroup>
                <span className="member-count">{(community.members || []).length}+ people</span>
              </div>
              <p className="community-description">{community.description}</p>
              <Button variant="contained" onClick={() => joinGroup(community.id, community.conversationId)} startIcon={<img src={vector} alt="join" style={{ width: '20px', height: '20px' }} />} className="join-group-btn">
                JOIN
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewCommunities;
